import type { RoutineView, ValidationContext } from '../types';

/**
 * True when neither the routine nor the workspace has this variable. Without
 * the workspace's globals the id may still be a global, so it is not missing.
 */
export function isMissingVariable(
  variableID: string,
  routine: RoutineView,
  ctx: Pick<ValidationContext, 'globalVariables'>,
): boolean {
  return (
    !routine.environmentVariables.some((v) => v.id === variableID) &&
    ctx.globalVariables != null &&
    !ctx.globalVariables.some((v) => v.id === variableID)
  );
}

/** As `isMissingVariable`, for a variable named in text. */
export function isMissingVariableName(
  name: string,
  routine: RoutineView,
  ctx: Pick<ValidationContext, 'globalVariables'>,
): boolean {
  return (
    !routine.environmentVariables.some((v) => v.name === name) &&
    ctx.globalVariables != null &&
    !ctx.globalVariables.some((v) => v.name === name)
  );
}
